module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"wasteTableTitle":"Atık Takip Tablosu","emissionType":"Atık Tipi"},"en":{"wasteTableTitle":"Waste Amount Table","emissionType":"Waste Type"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=2!./src/views/Analysis/Tabs/components/TotalWasteProduced.vue
// module id = nzIB
// module chunks = 1